//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/TaggedObjectCollection.js";
import "../Features/Features.FeatureCollection.js";
let d=[[],[[["geodesicSketch"],"CreateGeodesicSketchBuilder",{R_:{builder:"Features.GeodesicSketchBuilder"}},1,0],[["geodesicSketch"],"EditGeodesicSketch",{},1,0],[["geodesicIntersect"],"CreateGeodesicIntersectBuilder",{R_:{builder:"Features.GeodesicIntersectBuilder"}},1,0],[["geodesicProject"],"CreateGeodesicProjectBuilder",{R_:{builder:"Features.GeodesicProjectBuilder"}},1,0],[["geodesicOffset"],"CreateGeodesicOffsetBuilder",{R_:{builder:"Features.GeodesicOffsetBuilder"}},1,0],[["geodesicPoint"],"CreateGeodesicPointBuilder",{R_:{builder:"Features.GeodesicPointBuilder"}},1,0],[["geodesicLine"],"CreateGeodesicLineBuilder",{R_:{builder:"Features.GeodesicLineBuilder"}},1,0],[["geodesicSketch"],"CreateGeodesicTrimBuilder",{R_:{builder:"Features.GeodesicTrimBuilder"}},1,0],[["geodesicFillet"],"CreateGeodesicFilletBuilder",{R_:{builder:"Features.GeodesicFilletBuilder"}},1,0],[["geodesicChamfer"],"CreateGeodesicChamferBuilder",{R_:{builder:"Features.GeodesicChamferBuilder"}},1,0],[[],"CreateGeodesicResetBuilder",{R_:{builder:"Features.GeodesicResetBuilder"}},0,0]],[]];
SPLM.Features.GeodesicSketchCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Features.GeodesicSketchCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;